import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * A custom element that displays the product title, including the selected variant's name.
 * This component listens for variant update events and updates the displayed variant name accordingly.
 *
 * @extends {Component}
 */
class ProductTitleComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * Handles product select event and updates the displayed title.
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newTitle = html.querySelector(`product-title-component[data-block-id="${this.dataset.blockId}"]`);
        if (!newTitle) return;

        morph(this, newTitle);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-title] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-title-component')) {
  customElements.define('product-title-component', ProductTitleComponent);
}
